(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Noxar-componentes"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nxShop) return;
  window.__nxShop = true;

  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var shopOf = function (el) { return el.closest('[data-nx-shop]'); };

  /* ── Filtros / pestañas / paginación sin recargar (Section Rendering API) ── */
  function load(shop, url, push) {
    var id = shop.getAttribute('data-section-id');
    var u = new URL(url, location.origin);
    var fetchUrl = new URL(u); fetchUrl.searchParams.set('section_id', id);
    shop.classList.add('is-loading');
    return fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-nx-shop]');
        if (!next) throw new Error('no section');
        var wasOpen = shop.classList.contains('filters-open');
        shop.innerHTML = next.innerHTML;
        shop.classList.remove('is-loading');
        if (wasOpen) openFilters(shop, true);
        if (push) history.pushState({ nx: true }, '', u.pathname + u.search);
      })
      .catch(function () { location.href = u.toString(); });
  }

  function formUrl(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (val, key) { if (String(val).trim() !== '') p.append(key, val); });
    var qs = p.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function openFilters(shop, open) {
    shop.classList.toggle('filters-open', open);
    var scrim = shop.querySelector('.nx-scrim'); if (scrim) scrim.hidden = !open;
    document.documentElement.style.overflow = open && matchMedia('(max-width: 989px)').matches ? 'hidden' : '';
  }

  var timer;
  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-nx-filters]'); if (!form) return;
    clearTimeout(timer);
    timer = setTimeout(function () { load(shopOf(form), formUrl(form), true); }, e.target.type === 'number' ? 400 : 0);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-nx-filters]'); if (!form) return;
    e.preventDefault(); load(shopOf(form), formUrl(form), true);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nx-toggle-filters]');
    if (t) { var s = shopOf(t); openFilters(s, !s.classList.contains('filters-open')); return; }
    var a = e.target.closest('a[data-nx-link]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var shop = shopOf(a); if (!shop) return;
    e.preventDefault();
    var isPage = a.closest('.nx-pages');
    load(shop, a.href, true).then(function () {
      if (isPage) shop.querySelector('.nx-main').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var s = document.querySelector('[data-nx-shop].filters-open'); if (s) openFilters(s, false);
  });
  window.addEventListener('popstate', function () {
    var shop = document.querySelector('[data-nx-shop]');
    if (shop) load(shop, location.href, false);
  });

  /* ── Agregar al carrito: mismo flujo que Horizon (carrito lateral + checkout de Shopify) ── */
  function msg(form, text, isError) {
    var m = form.closest('.nx-card').querySelector('[data-nx-msg]');
    if (!m) return;
    m.textContent = text || ''; m.classList.toggle('is-error', !!isError);
    if (text && !isError) setTimeout(function () { m.textContent = ''; }, 3500);
  }

  function getCart() {
    var items = document.querySelector('cart-items-component');
    if (items && typeof items.fetchCartData === 'function') return items.fetchCartData();
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-nx-add]'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.classList.add('is-busy'); btn.textContent = 'Agregando…';

    import('@shopify/events').catch(function () { form.submit(); throw 0; }).then(function (mod) {
      var Evt = mod.CartLinesUpdateEvent;
      var fd = new FormData(form);
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId); });
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));
      var deferred = Evt.createPromise();
      form.dispatchEvent(new Evt({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }],
        promise: deferred.promise
      }));

      return fetch(root() + 'cart/add.js', {
        method: 'POST', body: fd, credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          return getCart().then(function (cart) {
            deferred.resolve({
              cart: Evt.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, sections: res.sections, didError: !!res.status, source: 'noxar-componentes', itemCount: 1 }
            });
            if (res.status) msg(form, res.description || res.message || 'No se pudo agregar.', true);
            else msg(form, 'Agregado al carrito ✓');
          });
        })
        .catch(function (err) { deferred.reject(err); msg(form, 'Error de conexión. Intenta de nuevo.', true); });
    })
      .catch(function () {}) /* sin módulo de carrito: ya se envió el formulario normal a /cart */
      .finally(function () { btn.classList.remove('is-busy'); btn.textContent = btn.getAttribute('data-label'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Noxar-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nxProduct) return;
  window.__nxProduct = true;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  function init(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var data = el.querySelector('[data-nxp-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var low = Number(el.dataset.low) || 3;
    var idInput = el.querySelector('[data-nxp-id]');
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var qtyInput = el.querySelector('[data-nxp-qty-input]');
    var addBtn = el.querySelector('[data-nxp-add]');
    var stage = el.querySelector('.nxp-stage img');

    function selected() {
      return [].map.call(el.querySelectorAll('[data-nxp-option]'), function (fs) {
        var a = fs.querySelector('.nxp-pill.is-active'); return a ? a.getAttribute('data-value') : null;
      });
    }
    function showMedia(id) {
      var t = el.querySelector('[data-nxp-thumb][data-media-id="' + id + '"]');
      if (!t || !stage) return;
      stage.srcset = t.dataset.srcset; stage.src = t.dataset.src;
      el.querySelectorAll('[data-nxp-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
    }
    function render() {
      var v = current;
      var stock = el.querySelector('[data-nxp-stock]');
      stock.className = 'nxp-stock mono';
      if (!v) { stock.textContent = 'Combinación no disponible'; stock.classList.add('is-out'); addBtn.disabled = true; return; }
      el.querySelector('[data-nxp-now]').textContent = v.price;
      el.querySelector('[data-nxp-now]').classList.toggle('is-sale', !!v.compare);
      var was = el.querySelector('[data-nxp-was]'), save = el.querySelector('[data-nxp-save]');
      was.hidden = save.hidden = !v.compare;
      if (v.compare) { was.textContent = v.compare; save.textContent = 'Ahorras ' + v.save; }
      if (!v.available) { stock.textContent = 'Agotado'; stock.classList.add('is-out'); }
      else if (v.qty !== null && v.qty <= low) { stock.textContent = v.qty === 1 ? 'Última pieza disponible' : 'Últimas ' + v.qty + ' piezas disponibles'; stock.classList.add('is-low'); }
      else { stock.textContent = 'En stock · listo para enviar'; stock.classList.add('is-ok'); }
      addBtn.disabled = !v.available;
      el.querySelector('[data-nxp-add-label]').textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      idInput.value = v.id;
      if (v.qty !== null) { qtyInput.max = v.qty; if (Number(qtyInput.value) > v.qty) qtyInput.value = Math.max(1, v.qty); } else { qtyInput.removeAttribute('max'); }
      // Marca valores sin stock según las demás opciones elegidas
      var sel = selected();
      el.querySelectorAll('[data-nxp-option]').forEach(function (fs, i) {
        fs.querySelector('[data-nxp-option-value]').textContent = sel[i];
        fs.querySelectorAll('.nxp-pill').forEach(function (p) {
          var test = sel.slice(); test[i] = p.getAttribute('data-value');
          var ok = variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
          p.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    el.addEventListener('click', function (e) {
      var pill = e.target.closest('.nxp-pill');
      if (pill) {
        pill.parentNode.querySelectorAll('.nxp-pill').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        var sel = selected();
        current = variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0];
        if (current && current.media) showMedia(current.media);
        if (current) history.replaceState(null, '', location.pathname + '?variant=' + current.id);
        render(); return;
      }
      var thumb = e.target.closest('[data-nxp-thumb]');
      if (thumb) { showMedia(thumb.dataset.mediaId); return; }
      var q = e.target.closest('[data-nxp-qty]');
      if (q) {
        var n = Math.max(1, (Number(qtyInput.value) || 1) + Number(q.dataset.nxpQty));
        if (qtyInput.max) n = Math.min(n, Number(qtyInput.max));
        qtyInput.value = n;
      }
    });

    render();

    // Productos relacionados (API de recomendaciones de Shopify)
    var recs = el.querySelector('[data-nxp-recs]');
    if (recs) {
      fetch(recs.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var res = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nxp-recs-result]');
        if (res && res.children.length) { recs.querySelector('[data-nxp-recs-grid]').appendChild(res); recs.hidden = false; }
      }).catch(function () {});
    }
  }

  // Agregar al carrito: mismo flujo que Horizon (carrito lateral + checkout de Shopify)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-nxp-form]'); if (!form) return;
    e.preventDefault();
    var el = form.closest('[data-nxp]');
    var btn = form.querySelector('[data-nxp-add]'), label = form.querySelector('[data-nxp-add-label]');
    var msg = form.querySelector('[data-nxp-msg]');
    var say = function (t, err) { msg.textContent = t || ''; msg.classList.toggle('is-error', !!err); if (t && !err) setTimeout(function () { msg.textContent = ''; }, 4000); };
    btn.classList.add('is-busy'); label.textContent = 'Agregando…';

    import('@shopify/events').catch(function () { form.submit(); throw 0; }).then(function (mod) {
      var Evt = mod.CartLinesUpdateEvent;
      var fd = new FormData(form);
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
      if (ids.length) fd.append('sections', ids.join(','));
      var qty = Number(fd.get('quantity')) || 1;
      var deferred = Evt.createPromise();
      form.dispatchEvent(new Evt({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: qty }], promise: deferred.promise }));
      return fetch(root() + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var items = document.querySelector('cart-items-component');
          var getCart = items && typeof items.fetchCartData === 'function' ? items.fetchCartData()
            : fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
          return getCart.then(function (cart) {
            deferred.resolve({ cart: Evt.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: res.sections, didError: !!res.status, source: 'noxar-producto', itemCount: qty } });
            if (res.status) say(res.description || res.message || 'No se pudo agregar.', true); else say('Agregado al carrito ✓');
          });
        })
        .catch(function (err) { deferred.reject(err); say('Error de conexión. Intenta de nuevo.', true); });
    })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-busy');
        label.textContent = btn.disabled ? 'Agotado' : 'Agregar al carrito';
      });
  });

  function run() { document.querySelectorAll('[data-nxp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-nxp]'); if (el) init(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
